module.exports = __webpack_public_path__ + "static/img/weixin_pay1.3fc763e1.jpg";